import cx from 'clsx';
import styles from './flow-content.module.css';

export function FlowContent({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}): React.JSX.Element {
  return (
    <div className={cx(styles.container, className)}>
      <div className={styles.content}>{children}</div>
    </div>
  );
}
